module.exports = __webpack_public_path__ + "static/media/viten-og-opplevelsessenter.575f7d79.jpg";